module.exports = __webpack_public_path__ + "static/ilustracao-ferramentas-323d37b88c963805485d4057a467c560.svg";